import { baseUrl } from '../http'
import axios from 'axios'

let reportsUrl = `${baseUrl}/reports`

export const reportsApi = {
  all(startDate, endDate) {
    return axios.get(`${reportsUrl}/all`, { params: {startDate, endDate}})
      .then(({ data: { success, result } }) => {
        if (success) {
          return result
        }
      });
  }
}

function parsePagination(pagination) {
  if (pagination === undefined || pagination == null) {
    return ""
  }
  return `?items=${pagination.perPage}&page=${pagination.currentPage - 1}`
}
